module.exports = __webpack_public_path__ + "static/media/lights_100.61438418.ico";